import { Check } from 'lucide-react';

export function ErklaerungStep4Done() {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mb-6">
        <Check className="w-10 h-10 text-green-600" strokeWidth={2.5} />
      </div>
      <h1 className="text-3xl font-bold text-slate-900 mb-3">Vielen Dank!</h1>
      <p className="text-slate-600 max-w-md text-base leading-relaxed">
        Die Kostenübernahmeerklärung wurde an die FOM-Buchhaltung übermittelt. Eine Kopie ist an Ihre
        Mail-Adresse unterwegs.
      </p>
      <p className="mt-6 text-sm text-slate-400">
        Sie können dieses Fenster schließen.
      </p>
    </div>
  );
}
